import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import style from './style.scss'
import SystemModel from '/chat/src/redux/model/system/model';

import CogImage from '/chat/src/components/SVGImages/Cog'

class SettingsButton extends Component {
    render() {
        let defaultStyle = style.NormalSettings
        if(!this.props.isNormalView)  defaultStyle = style.MobileSettings
        return (
            <div
            onClick={()=> {this.props.dispatch(SystemModel.setRoute('Settings'))}}
            className={defaultStyle}>
                 <CogImage color={'white'}/>
            </div>
        );
    }
}
export default connect(state => {
    return {
        isNormalView: SystemModel.isNormalView(state)
    }
})(SettingsButton);



// WEBPACK FOOTER //
// ./components/Buttons/SettingsButton/index.js